import React from 'react'
import DropdownSelect from '../../../../../../common/inputs/dropdownSelect/DropdownSelect'
import { SupplyTypeOption } from '../../../../../../../@types/dropdown-types'
import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'

const SupplyType: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  insertionData,
  onChange,
  screenName,
  wrapperClassName = 'grid-item one-whole',
}) => {
  return (
    <div className={wrapperClassName}>
      <DropdownSelect
        id='supply-type'
        name='supplyType'
        label='wizard.screen.otherFacilities.supplyType'
        value={insertionData.supplyType}
        noInformation={SupplyTypeOption.NO_INFORMATION}
        options={{
          translationKeyGroup: 'wizard.screen.otherFacilities.supplyTypeOptions',
          options: Object.keys(SupplyTypeOption),
        }}
        onChange={(value) => onChange({ screen: screenName, property: 'supplyType' }, value.value!)}
        allowEmpty
      />
    </div>
  )
}

export default SupplyType
